import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RecalculateQueueComponent } from '../recalculate-queue/recalculate-queue.component';

@Component({
  selector: 'app-dialog-recalucate-queue',
  templateUrl: './dialog-recalucate-queue.component.html',
  styleUrls: ['./dialog-recalucate-queue.component.css']
})
export class DialogRecalucateQueueComponent  {
  
  constructor(
    private  dialogRef:  MatDialogRef<RecalculateQueueComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { buttonCancel: string }) { }
}
